export default "assets/images/fond-404-0fb21582.png";